import useApi from '../../../services/useApi'
import useFilters from '../../../hook/useFilters'
import moment from 'moment'
import {useState} from 'react'

const useGetSalesRepTypeReport = () => {
  const Api = useApi()
  const [dateRange] = useState(() => JSON.parse(localStorage.getItem('selectedDateRange') || '{}'))

  const initialFilters = {
    start_date: dateRange?.startDate ?? moment().subtract(3, 'months').format('YYYY-MM-DD'),
    end_date: dateRange?.endDate ?? moment().format('YYYY-MM-DD'), // includes today
    sort_by: 'total_shipping/-1',
    // sales_rep_type: '',
  }

  const {filters, onDateChange, onSortingChange, setMultipleFilters} = useFilters(initialFilters, {
    sortType: 'number',
  })

  const {data: response, isFetching} = Api.useGetQuery(
    '/analytics/shipping-report/sales-rep-type',
    {
      queryId: 'shipping-sales-rep-type-report',
      filters,
      isToast: false,
      isErrorPageRedirection: false,
    }
  )

  const onChangeSalesRepTypeFilter = (values: any[]) => {
    setMultipleFilters({
      sales_rep_type: values?.map((item: {value: string}) => item?.value).join(','),
      page: 1,
    })
  }

  return {
    reportData: response?.data || [],
    isLoading: isFetching,
    filters,
    onSortingChange,
    handleSalesRepTypeReportDateChange: onDateChange,
    pagination: response?.meta?.pagination || {},
    onChangeSalesRepTypeFilter,
  }
}

export default useGetSalesRepTypeReport
